/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcDailyOrgSummaryResponse { 
    org_id?: string;
    /**
     * Timestamp in UTC when the row was inserted in table
     */
    created_ts?: Date;
    /**
     * Timestamp in UTC when the row was updated in table
     */
    updated_ts?: Date;
    /**
     * Date of the usage in YYYY-MM-DD.
     */
    usage_date?: string;
    /**
     * vmc usage json
     */
    usage_json?: object;
}

